import type React from "react";
import type { LocalizedText } from "./settingsListTypes";

export type TextResolver = (value: LocalizedText) => string;

export type ConfirmActionOptions = {
  title: LocalizedText;
  content?: React.ReactNode;
  okText?: LocalizedText;
  cancelText?: LocalizedText;
  danger?: boolean;
  autoFocusButton?: "ok" | "cancel" | null;
  onConfirm: () => Promise<void> | void;
  onCancel?: () => void;
};

export type ConfirmModalApi = {
  confirm: (config: {
    title: string;
    content?: React.ReactNode;
    okText?: string;
    okButtonProps?: { danger?: boolean };
    cancelText?: string;
    focusable?: { autoFocusButton?: "ok" | "cancel" | null };
    onOk?: () => Promise<void> | void;
    onCancel?: () => void;
  }) => unknown;
};

export function confirmAction(
  modal: ConfirmModalApi,
  text: TextResolver,
  {
    title,
    content,
    okText = "OK",
    cancelText = "Cancel",
    danger = false,
    autoFocusButton,
    onConfirm,
    onCancel,
  }: ConfirmActionOptions
) {
  modal.confirm({
    title: text(title),
    content: typeof content === "string" ? text(content as LocalizedText) : content,
    okText: text(okText),
    okButtonProps: danger ? { danger: true } : undefined,
    cancelText: text(cancelText),
    focusable: autoFocusButton === undefined ? undefined : { autoFocusButton },
    onOk: onConfirm,
    onCancel,
  });
}
